<div class="row">
  <div class="col-md-12">
    <div class="card mb-0">
      <div class="card-block">
        <div class="row">
          <div class="col-md-3 push-right">
            <ng-select
              *ngIf="colRemove"
              (change)="handleColumns()"
              [items]="columns"
              [(ngModel)]="selectedColumnsCopy"
              [placeholder]="'Hide/Show Columns'"
              [clearable]="false"
              [searchable]="false"
              [multiple]="true"
              [closeOnSelect]="false"
            >
              <ng-template ng-multi-label-tmp>
                <span style="display: block" class="ng-placeholder"
                  >Hide/Show Columns</span
                >
              </ng-template>
              <ng-template
                ng-option-tmp
                let-item="item"
                let-item$="item$"
                let-index="index"
              >
                <input
                  id="item-{{ index }}"
                  type="checkbox"
                  [ngModel]="item$.selected"
                />
                {{ item.title }}
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-9 d-flex justify-content-end align-items-center">
            <label *ngIf="colRemove" class="mr-1">
              <input type="checkbox" [(ngModel)]="includeHiddenColumns" />
              Export Hidden Columns
            </label>
            <button
              *ngIf="exportXLSX"
              class="btn btn-sm btn-primary align-text-center"
              (click)="downloadFile()"
            >
              <div
                *ngIf="downloading"
                class="spinner-border text-white mr-1"
                style="width: 1rem; height: 1rem"
                role="status"
              ></div>
              Export to .XLSX
            </button>
          </div>
        </div>

        <ng-content></ng-content>
        <table
          #dtTableElement
          style="width: 100%; cursor: pointer"
          *ngIf="!loading"
          datatable
          [dtOptions]="dtOptions"
          class="row-border hover nowrap"
        ></table>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="contextMenuPosition"
  class="context-menu"
  [ngStyle]="{
    'top.px': contextMenuPosition.y,
    'left.px': contextMenuPosition.x
  }"
>
  <button (click)="onDelete()">Delete</button>
</div>
